export const setMyAgentProfile = (agent) => ({
    type: "SET_AGENT_PROFILE",
    payload: agent,
  });

  export const setMyAgentProfilePresences = (presencesProfile) => {
    return {
      type: "SET_MY_AGENT_PROFILE_PRESENCES",
      payload: presencesProfile, 
    };
  };